var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div style=\"height: 90vh\" class=\"inline-block w-full max-w-screen-sm p-6 mx-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xla rounded my-auto\"><div id=\"connect-container\" class=\"w-full h-full\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/applications/income/finicity_connect_modal.jade
// module id = 1137
// module chunks = 0